const styles = () => ({
  container: {
    padding: 60,
    textAlign: "left",
  },
  subHeader: {
    fontSize: "1.15rem",
    fontWeight: "bold",
    marginBottom: 20,
  },
  paragraph: {
    fontSize: "1rem",
    marginBottom: 20,
  },
})

export default styles
